import { Col } from 'reactstrap';

export function Footer() {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <Col md="12" className="footer-copyright text-center">
            <p className="mb-0">Copyright {new Date().getFullYear()} © TLN Connect</p>
          </Col>
        </div>
      </div>
    </footer>
  );
}
